import { render } from "./Institutions.vue?vue&type=template&id=3c7a49e5&ts=true"
import script from "./Institutions.vue?vue&type=script&lang=ts"
export * from "./Institutions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__